<template>
    <v-main class="system_main_background_color">
        <v-container fluid v-show="showTab">
			<v-row class="system_toolbar system_toolbar_color d-flex justify-content-between">
				<v-tabs background-color="transparent" hide-slider dark>
                    <v-img class="mt-2" :src="checkImagePath(GET_PREFERENCES.find(x => x.parameter == 'system_toolbar_image')?.value ?? null)" contain max-height="90" max-width="90" />
                    <v-dialog max-width="1000" v-model="eventFormDialog" persistent>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="log_in_button_text_color mr-1" rounded style="margin-left: auto; margin-top: 5px;"
                                plain  v-bind="attrs" v-on="on">
                                <v-icon size="25" left>
                                    mdi-draw-pen
                                </v-icon>
                                <span class="underline-animation system_font_family_primary fillup-button-textsize system_main_label_color" style=" font-size: 1rem; font-weight: bold;">
                                    Log in
                                </span>
                            </v-btn>
                        </template>
                    </v-dialog>
				</v-tabs>
			</v-row>
		</v-container>
        <v-container v-if="isDesktop" fluid>
            <v-row  class="system_toolbar system_toolbar_color d-flex w-auto justify-content-between ">
                <div>
                    <v-tabs background-color="transparent" hide-slider dark>
                        <v-img class="mt-2" :src="checkImagePath(GET_PREFERENCES.find(x => x.parameter == 'system_toolbar_image')?.value ?? null)" contain max-height="90" max-width="90"/>
                    </v-tabs>
                </div>
                <v-dialog max-width="1000" v-model="eventFormDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="black" class="mt-1" rounded 
                            plain  v-bind="attrs" v-on="on">
                            <v-icon size="30" left class="system_main_label_color">
                                mdi-draw-pen
                            </v-icon>
                            <span class="underline-animation system_font_family_primary fillup-button-textsize system_main_label_color" style=" font-size: 1.1rem; font-weight: bold;">
                                Log in to event
                            </span>
                        </v-btn>
                    </template>
                </v-dialog>
            </v-row>
        </v-container>
        <v-container fluid>
            <!-- <div class="d-flex justify-content-center" style="height: auto;">
                <v-dialog max-width="1000" v-model="eventFormDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="#17468f" icon rounded
                            fab plain  v-bind="attrs" v-on="on">
                            <v-icon size="30" left>
                                mdi-draw-pen
                            </v-icon>
                            <span class="underline-animation fillup-button-textsize" style="font-family: Evogria; font-size: 1.1rem; font-weight: bold;">
                                Log in to event
                            </span>
                        </v-btn>
                    </template>
                </v-dialog>
            </div> -->
            <v-row class="px-6">
                <v-col v-if="GET_PREFERENCES.find(x => x.parameter == 'system_landing_image')?.value">
                    <v-img 
                        :src="checkImagePath(GET_PREFERENCES.find(x => x.parameter == 'system_landing_image')?.value ?? null)"
                        :lazy-src="checkImagePath(GET_PREFERENCES.find(x => x.parameter == 'system_lazy_image')?.value ?? null)"
                        alt="Placeholder"
                        contain
                        width="100%"
                        height="100%"
                    ></v-img>
                </v-col>
            </v-row>
            <v-expansion-panels v-model="showActivities" v-if="settings.activities == 1">
                <v-expansion-panel>
                    <v-expansion-panel-header class="small-header system_expansion_color">
                        <span class="text-center system_font_family_primary system_expansion_color" style="font-size: 2rem; font-weight: bold;">
                            Activities
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="system_expansion_background">
                        <v-divider :thickness="50"></v-divider>
                        <ActivitiesCarouselComponentVue/>
                        <v-divider :thickness="50"></v-divider>                        
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels v-model="showSitemapDesktop" v-if="settings.event_sitemap == 1">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="small-header system_expansion_color">
                            <span class="text-center system_font_family_primary" style="font-size: 2rem; font-weight: bold;">
                                Event Sitemap
                            </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content  style="font-size: 1.4rem; font-weight: bold;" class="justify-content-between system_font_family_primary system_expansion_background">
                            <v-divider :thickness="50"></v-divider>
                                <EventSitemapCarouselComponent/>                        
                            <v-divider :thickness="50"></v-divider>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            <div class="d-flex justify-content-center pa-4" style="height: auto;">
                <v-dialog :width="height('480')" v-model="eventFormDialog" persistent>
                    <v-card class="login-card system_font_family_primary" style="overflow:hidden; border-radius:16px;">

                        <!-- Gradient header -->
                        <div class="login-header">
                            <v-btn icon small @click="closeEventForm" class="login-close-btn" color="rgba(255,255,255,0.7)">
                                <v-icon size="18">mdi-close</v-icon>
                            </v-btn>
                            <div class="login-header-icon">
                                <v-icon size="38" color="white">mdi-calendar-star</v-icon>
                            </div>
                            <div class="login-header-title">Event Login</div>
                            <div class="login-header-sub">Please enter your credentials to continue</div>
                        </div>

                        <!-- Body -->
                        <div class="login-body">

                            <!-- data_grouping == 1: Employee ID OTP -->
                            <div v-if="settings.data_grouping == 1">
                                <div class="login-field-label">
                                    <v-icon size="16" color="#90caf9" class="mr-1">mdi-badge-account-outline</v-icon>
                                    Employee ID
                                </div>
                                <v-otp-input
                                    v-model="employeeId"
                                    length="4"
                                    type="number"
                                    class="login-otp"
                                ></v-otp-input>

                                <!-- Auto-populated info -->
                                <div v-if="selectedEmployeeName" class="login-info-block mt-4">
                                    <div class="login-info-row">
                                        <v-icon size="16" color="#90caf9" class="mr-2">mdi-account-outline</v-icon>
                                        <span class="login-info-label">Name</span>
                                        <span class="login-info-value">{{ selectedEmployeeName }}</span>
                                    </div>
                                    <div class="login-info-row" v-if="selectedEmployee.department_name">
                                        <v-icon size="16" color="#90caf9" class="mr-2">mdi-account-group-outline</v-icon>
                                        <span class="login-info-label">Department</span>
                                        <span class="login-info-value">{{ selectedEmployee.department_name }}</span>
                                    </div>
                                    <div class="login-info-row" v-if="selectedEmployeeDepartment">
                                        <v-icon size="16" color="#90caf9" class="mr-2">mdi-office-building-outline</v-icon>
                                        <span class="login-info-label">Company</span>
                                        <span class="login-info-value">{{ selectedEmployeeDepartment }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- data_grouping == 2: Company selector -->
                            <div v-if="settings.data_grouping == 2">
                                <div class="login-field-label">
                                    <v-icon size="16" color="#90caf9" class="mr-1">mdi-office-building-outline</v-icon>
                                    Select Your Company
                                </div>
                                <v-autocomplete
                                    v-model="company_id"
                                    @keyup.enter="filterGuests()"
                                    @change="filterGuests()"
                                    :items="company_items"
                                    :search-input.sync="company_search"
                                    :loading="company_loading"
                                    cache-items
                                    placeholder="Search company..."
                                    item-text="name"
                                    item-value="id"
                                    hide-no-data
                                    hide-details
                                    solo
                                    class="login-company-select"
                                    background-color="#1a2a4a"
                                >
                                    <template v-slot:prepend-inner>
                                        <v-icon color="#90caf9" size="20" class="mt-1 mr-1">mdi-magnify</v-icon>
                                    </template>
                                </v-autocomplete>

                                <div v-if="company_id" class="login-selected-badge mt-3">
                                    <v-icon size="16" color="#66bb6a" class="mr-1">mdi-check-circle</v-icon>
                                    <span style="color:#66bb6a; font-size:13px;">Company selected</span>
                                </div>
                            </div>

                            <!-- Submit button -->
                            <v-btn
                                @click="submitCredentials"
                                :disabled="checkDisablingOfSubmitByGrouping()"
                                class="login-submit-btn mt-5"
                                block
                                depressed
                                large
                            >
                                <v-icon left size="20">mdi-login-variant</v-icon>
                                Login
                            </v-btn>
                        </div>
                    </v-card>
                </v-dialog>
            </div>
        </v-container>          
    </v-main>
</template>

<script>
import Swal from 'sweetalert2';
import axios from 'axios';
import { mapGetters } from 'vuex';
import ActivitiesCarouselComponentVue from '@/components/expansions/ActivitiesCarouselComponent.vue';
import EventSitemapCarouselComponent from '@/components/expansions/EventSitemapCarouselComponent.vue';
import moment from 'moment';
import QrScanner from 'qr-scanner';

export default {
    data() {
        return {
            last_name: '',
            first_name: '',
            showActivities: -1,
            showSitemapDesktop: -1,
            middle_name: '',
            employeeDatas: [],
            eventFormDialog: false,
            deptID: null,
            companyID: null,
            employeeDataLocalID: null,
            employeeId: null,
            department: '',
            isDesktop: window.innerWidth > 1000,
            showTab: window.innerWidth <= 1000,
            data: [],
            items: [
                {
                src: require('@/assets/banner.jpg.png'),
                },
                {
                src: require('@/assets/banner.jpg.png'),
                },
                {
                    src: require('@/assets/banner.jpg.png'),
                },
            ],
            currentItem: 0, 
            settings: {
				nomination_start_date: null,
				nomination_end_date: null,
				share_your_moments: null,
				star_of_the_night: null,
				activities: null,
				program_flow: null,
				event_sitemap: null,
				data_grouping: null,
				voting_start_date: null,
				voting_end_date: null,
            },
            dropdowns:{
                company_list: []
            },
            company_id: null,
            companySearched: false,
            selected_company: {},
            guest_items: [],
            search: '',
            loading: false,
            company_search: '',
            company_items: [],
            company_loading: false,
            withGuestID: [],
            with_guest_search: '',
            with_guest_items: [],
            list_loading:{
                with_guest: false
            },
            all_guest: [],
            unique_code: '',
            qrPreview: null,
        };
    },
    computed: {
        ...mapGetters([
				"GET_NEW_MASTER_DATA",
                "GET_PREFERENCES",
                "GET_EVENT_ID",
                "GET_EVENT_NAME"
			]),
        selectedEmployee() {
            if (this.employeeId) {
                const employee = this.employeeDatas.find(employee => employee.employee_id === this.employeeId);
                return employee || { 
                    full_name: '', 
                    company_name: '', 
                    employee_data_local_id: '', 
                    department_id: '', 
                    employment_duration_label: '' 
                };
            } else {
                return { 
                    full_name: '', 
                    company_name: '', 
                    employee_data_local_id: '', 
                    department_id: '', 
                    employment_duration_label: '' 
                };
            }
        },
        selectedEmployeeName() {
            if (this.selectedEmployee.full_name) {
            return this.selectedEmployee.full_name;
            }
        },
        selectedEmployeeDepartment() {
            this.employeeDataLocalID = this.selectedEmployee.employee_data_local_id;
            this.deptID = this.selectedEmployee.department_id;
            this.companyID = this.selectedEmployee.company_name;
            this.employment_duration_label = this.selectedEmployee.employment_duration_label;
            return this.selectedEmployee.company_name;
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
		// this.getGroupingSettings();
		// this.getCompanyDropdowns();
	},
    components:{
		EventSitemapCarouselComponent,
        ActivitiesCarouselComponentVue
	},
	beforeDestroy() {
	    window.removeEventListener('resize', this.handleResize);
	},
    created() {
        this.showActivities = 0;
        this.showSitemapDesktop = 0;
    },
    methods: {
        handleResize() {
            this.isDesktop = window.innerWidth > 1000;
            this.clicked = this.isDesktop;
            this.clicked = !this.clicked;
            this.showTab = window.innerWidth <= 1000;
	    },
        closeEventForm() {
            this.employeeId = null;
            this.companyID = null;
            this.company_id = null;
            this.withGuestID = [];
            this.eventFormDialog = !this.eventFormDialog;
            this.companySearched = false;
            this.unique_code = '';
        },
        async fetchData() {
            let payload = {
                url: "submit-credentials",
                id: this.data,
                event_id: this.GET_EVENT_ID
            };

            try {
            // let response = await axios.get(process.env.VUE_APP_API_HOST + '/api/submit-credentials');
                this.$store.dispatch("urlGet",  payload).then((res)=>{
                this.employeeDatas = res.allEmployeeData;
                })
                this.$store.commit('NEW_MASTER_DATA', true);
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Failed to fetch data!',
                });
            }
        },
        async submitCredentials() {
            if (this.settings.data_grouping == 2) {
                await this.loginByCompanyId();
                return;
            }

            Swal.fire({
                title: 'Please Wait',
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
            });

            if (!this.employeeId) {
                Swal.fire({
                    icon: 'error',
                    title: 'Please Input',
                    allowOutsideClick: false,
                    text: 'Please enter your reference number.',
                    customClass: { confirmButton: 'orange-button' }
                });
                return;
            }
            this.triggerLogin();
        },
        async loginByCompanyId() {
            if (!this.company_id) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Select a Company',
                    text: 'Please select your company before logging in.',
                });
                return;
            }

            Swal.fire({
                title: 'Please Wait',
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
            });
            Swal.showLoading();

            try {
                const res = await this.$store.dispatch('urlPost', {
                    url: 'loginByCompany',
                    company_id: this.company_id,
                    event_id: this.GET_EVENT_ID,
                });

                localStorage.setItem('token', res.token);
                localStorage.setItem('refNumber', this.company_id);
                localStorage.setItem('loginType', 'company');

                Swal.close();
                this.eventFormDialog = false;
                this.$router.push('/welcome');
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Login Failed',
                    text: error?.response?.data?.message ?? 'Unable to log in. Please try again.',
                });
            }
        },
        font_size() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return "15"
                case 'sm': return "15"
                case 'md': return "20"
                case 'lg': return "20"
                case 'xl': return "20"
            }
        },
        async getGroupingSettings(){
			let payload = {
                type: 'Expansions',
                url: 'moduleSettings',
            };
            await this.$store.dispatch("urlGet", payload).then((res)=>{
                res.forEach(e=>{
                    Object.keys(this.settings).filter(el=>{
                        if(el == e.parameter){
                            this.settings[el] = parseInt(e.value)
                        }
                    });
                })
            })
		},
        getCompanyDropdowns(){
			let payload = {
				url: 'getAllCompany',
                event_id: this.GET_EVENT_ID
			}
			this.$store.dispatch('urlGet', payload).then((res)=>{
				this.dropdowns.company_list = res.data
			});
		},
        filterGuests(){
            this.guest_items = [];
			this.companySearched = true;
			this.selected_company = this.dropdowns.company_list.find((x)=> x.id == this.company_id);
			// this.selected_company.ticket_numbers = this.selected_company.company_tickets.map(x => x.ticket_num)
            this.employeeId = null;
		},
        querySelections (v) {
			this.loading = true
            let filtered = this.all_guest;
            let filtered_items = filtered.filter((x=>{
                if(x.full_name.match(v) && x.company_id == this.company_id){
                    return x;
                }
                else if (x.full_name.toLowerCase().indexOf(v) > -1 && x.company_id == this.company_id){
                    return x;
                }
            }));
            this.guest_items = filtered_items
            this.loading = false;

            // console.log(filtered)
			// let payload = {
			// 	url: 'getEmployeeSearch',
			// 	company_id: this.company_id,
			// 	search: this.search,
            //     event_id: this.GET_EVENT_ID
			// }
			// this.$store.dispatch('urlPost', payload).then((res)=>{
			// 	this.guest_items = res
			// 	this.loading = false
			// })
		},
        getWithGuest(){
            // this.list_loading.with_guest = true
            // let payload = {
			// 	url: 'getEmployeeSearch',
			// 	company_id: this.company_id,
            //     event_id: this.GET_EVENT_ID
			// }
			// this.$store.dispatch('urlPost', payload).then((res)=>{
            //     this.with_guest_items = res.filter(x => x.status_id == 1 && x.employee_id != this.employeeId);
            //     this.list_loading.with_guest = false
            //     // this.with_guest_items = res.filter((x) => x.employee_id != this.employeeId);
			// })
        },
        querySelectionsCompany (v) {
			this.company_loading = true
            let filtered = this.dropdowns.company_list;
            if(v){
                filtered = filtered.filter(item => item.name.toLowerCase().indexOf(v) > -1 );
                this.company_items = filtered
            }else{
                this.company_items = filtered
            }

			this.company_loading = false

			// let payload = {
			// 	url: 'searchCompany',
			// 	company_id: this.company_id,
			// 	search: this.search,
            //     event_id: this.GET_EVENT_ID
			// }
			// this.$store.dispatch('urlPost', payload).then((res)=>{
			// 	this.company_items = res
			// 	this.company_loading = false
			// })
		},
        selectGuest(item){
            item.selected = !item.selected
        },
        checkImagePath(image_path) {
            return process.env.VUE_APP_API_HOST + "/" + image_path
        },
        getAllGuest(){
            let payload = {
                url: 'getAllGuest',
                event_id: this.GET_EVENT_ID
            }
            this.$store.dispatch('urlPost', payload).then(res=>{
                this.all_guest = res.data
            })
        },
        height(width) {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return "100%"
                case 'sm': return "100%"
                case 'md': return width
                case 'lg': return width
                case 'xl': return width
            }
        },
        checkGuestCode(){
            let findGuest = this.all_guest.find(e=> e.unique_code == this.unique_code);
            if(findGuest){
                this.employeeId = findGuest.employee_id;
            }else{
                Swal.fire({
                    title: "Code Not Valid!",
                    text: "Please double check unique code.",
                    icon: "info"
                });
                this.resetUniqueCode();
                return false;
            }
        },
        async onQrImageUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            const imageUrl = URL.createObjectURL(file);
            this.qrPreview = imageUrl;

            try {
                const result = await QrScanner.scanImage(imageUrl, { returnDetailedScanResult: false });
                if (result) {
                    this.unique_code = result.data;
                    this.checkGuestCode();
                } 
            } catch (e) {
                console.log(e)
                Swal.fire({
                    title: e.toUpperCase(),
                    text: "",
                    icon: "info"
                });
                this.resetUniqueCode()
            } finally {
                URL.revokeObjectURL(imageUrl);
            }
        },
        resetUniqueCode(){
            this.unique_code = '';
            this.qrPreview = null;
        },
        checkDisablingOfSubmitByGrouping(){
            if(this.settings.data_grouping == 1){
                return this.employeeId ? false : true;
            } else if(this.settings.data_grouping == 2){
                return !this.company_id;
            }
            return false;
        },
        async triggerLogin(){
            Swal.showLoading();
            let employee_data = this.employeeDatas.find(x=> x.employee_id == this.employeeId);

            if (!employee_data) {
                Swal.fire({
                    icon: 'error',
                    title: 'Not Found',
                    text: 'Employee record not found. Please check your reference number.',
                    allowOutsideClick: false,
                    customClass: { confirmButton: 'orange-button' }
                });
                this.data = [];
                this.employeeId = null;
                return;
            }

            this.employeeDataLocalID = employee_data.employee_data_local_id;
            this.deptID = employee_data.department_id;
            this.data.push({
                employee_data_id: this.employeeDataLocalID,
                employee_id: this.employeeId,
                department_id: this.deptID,
                tenure_code_id: this.employment_duration_label,
                company_id: this.company_id,
            });
            localStorage.setItem('refNumber', this.employeeId);
            this.withGuestID = this.with_guest_items.filter((x)=> x.selected == true).map(e=> e.employee_id)
            let payload = {
                url: "selected-id",
                id: this.data,
                with_guest: this.withGuestID,
                company_id: this.company_id,
                event_id: this.GET_EVENT_ID
            };
            try {
                await this.$store.dispatch("urlPost", payload).then((res) => {
                    Swal.fire({
                        title: 'Processing',
                        allowOutsideClick: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                    });
                    Swal.showLoading();
                    localStorage.setItem('token', res.token );
                    this.$store.commit('REMAINING_GUEST', res.remaining_guest)
                    this.$store.commit('REMIND_GUEST', 1)
                    Swal.close();
                    this.eventFormDialog = false;
                    this.$router.push('/welcome');
                });
            } catch (error) {
                Swal.fire({
                    title: "<strong><u>Error</u></strong>",
                    text: error?.response?.data?.message ?? 'Login failed. Please try again.',
                    icon: 'warning',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'orange-button',
                    }
                });
            }

            this.data = [];
            this.employeeId = null;
        }
    },
    watch:{
        search (val) {
            if(!val){
				this.guest_items = []
            }else{
                val && val !== this.employeeId && this.querySelections(val)
            }
		},
        company_search:{
            handler(val){
                if(!val){
                    this.company_items = []
                }else{
                    try{
                        let filtered = this.dropdowns.company_list;
                        let filtered_items = filtered.filter((x=>{
                            if(x.name.match(val)){
                                return x;
                            }
                            else if (x.name.toLowerCase().indexOf(val) > -1){
                                return x;
                            }
                        }));
                        this.company_items = filtered_items
                    }catch(error){
                        alert(error)
                    }
                }
            },
            deep: true,
            immediate: true
		},
        employeeId (val){
			let guest_details = this.employeeDatas.find((x)=> x.employee_id == val);
			if(guest_details){
				this.selected_company.table_num = guest_details.table_num;
				this.selected_company.buffet_table = guest_details.buffet_meal_id;
				this.selected_company.guest_name = guest_details.full_name;
			}else{
				this.selected_company.table_num = '';
				this.selected_company.buffet_table = '';
				this.selected_company.guest_name = '';
			}
		},
        GET_EVENT_ID:{
            handler(val){
                this.fetchData();
                this.getGroupingSettings();
		        this.getCompanyDropdowns();
                this.getAllGuest();
            },
            immediate: true
        },
        GET_EVENT_NAME: {
            handler(val){
                document.title = `${val ? val.toUpperCase() : ''} ${moment().format('YYYY')}`;
            }
        }
    }
};
</script>

<style scoped>
    .transparent-btn { background-color: transparent; border: none; }
    .black-font { color: black !important; }
    .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }
    #ingco-logo-img{
        height: 40px;
    }
    .slide-enter, .slide-leave-to {
        transform: translateX(-6%);
    }
    body {
        overflow: hidden;
    }
    .flex-container {
        display: flex;
        align-items: center;
    }
    .flex-container span {
        margin-right: 10px; 
    }
    .adaptive-text {
        font-size: 14px;
        justify-content: center;
    }
    @media (max-width: 600px) {
        .adaptive-text {
        font-size: 12px; 
        }
    }
    .responsive-img {
        height: 100%;
        width: 100%;
        display: block;
        margin: 0 auto;
    }
    @media (max-width: 600px) {
        .responsive-img {
            height: 100%;
            width: 100%;
            display: block;
            margin: 0 auto;
        }
    }
    
    .fillup-button-textsize{
        font-size: 14px;
        justify-content: center;
    }

    .carousel-name-text-font {
        font-size: 50px; 
    }

    .carousel-desc-name-text-font {
        font-size: 40px; 
    }
    @media (max-width: 600px) {
        .fillup-button-textsize {
            font-size: 10px; 
        }

        .carousel-name-text-font {
            font-size: 30px; 
        }
         .carousel-desc-name-text-font {
            font-size: 20px; 
        }
    }
    .small-header {
        padding-top: 1px; /* Adjust as needed */
        padding-bottom: 1px; /* Adjust as needed */
    }
    body {
    background-color: black;
    }
       .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height:auto; /* Adjust this value as needed */

    }
    ::v-deep .white-text-field input {
        color: white !important;
    }

    /* ── Login Dialog ─────────────────────────────────────── */
    .login-card {
        background: #0d1b2e !important;
        border: 1px solid rgba(255,255,255,0.08);
        box-shadow: 0 24px 60px rgba(0,0,0,0.7) !important;
    }

    .login-header {
        position: relative;
        background: linear-gradient(135deg, #17468f 0%, #0d2a5e 60%, #091a3e 100%);
        padding: 36px 24px 28px;
        text-align: center;
    }

    .login-close-btn {
        position: absolute;
        top: 12px;
        right: 12px;
    }

    .login-header-icon {
        width: 68px;
        height: 68px;
        border-radius: 50%;
        background: rgba(255,255,255,0.12);
        border: 2px solid rgba(255,255,255,0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 14px;
        backdrop-filter: blur(4px);
    }

    .login-header-title {
        font-size: 22px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 0.04em;
        margin-bottom: 6px;
    }

    .login-header-sub {
        font-size: 12px;
        color: rgba(255,255,255,0.55);
        letter-spacing: 0.02em;
    }

    .login-body {
        padding: 28px 28px 32px;
    }

    .login-field-label {
        font-size: 12px;
        font-weight: 600;
        color: #90caf9;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
    }

    /* OTP boxes styling override */
    ::v-deep .login-otp .v-input__control {
        justify-content: center;
    }
    ::v-deep .login-otp .v-otp-input__field {
        background: #1a2a4a !important;
        border: 1px solid rgba(144,202,249,0.3) !important;
        border-radius: 8px !important;
        color: #ffffff !important;
        font-size: 22px !important;
        font-weight: 700 !important;
        width: 54px !important;
        height: 54px !important;
        caret-color: #90caf9 !important;
    }
    ::v-deep .login-otp .v-otp-input__field:focus {
        border-color: #90caf9 !important;
        box-shadow: 0 0 0 2px rgba(144,202,249,0.2) !important;
    }

    /* Company autocomplete override */
    ::v-deep .login-company-select .v-input__slot {
        border-radius: 10px !important;
        border: 1px solid rgba(144,202,249,0.25) !important;
        min-height: 48px !important;
    }
    ::v-deep .login-company-select input,
    ::v-deep .login-company-select .v-select__selection {
        color: #e3f2fd !important;
        font-size: 14px !important;
    }
    ::v-deep .login-company-select input::placeholder {
        color: rgba(255,255,255,0.35) !important;
    }

    .login-info-block {
        background: rgba(23, 70, 143, 0.15);
        border: 1px solid rgba(144,202,249,0.15);
        border-radius: 10px;
        padding: 12px 14px;
    }

    .login-info-row {
        display: flex;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid rgba(255,255,255,0.05);
    }
    .login-info-row:last-child { border-bottom: none; }

    .login-info-label {
        font-size: 12px;
        color: rgba(255,255,255,0.45);
        width: 90px;
        flex-shrink: 0;
    }

    .login-info-value {
        font-size: 13px;
        color: #e3f2fd;
        font-weight: 500;
        flex: 1;
    }

    .login-selected-badge {
        display: flex;
        align-items: center;
    }

    .login-submit-btn {
        background: linear-gradient(135deg, #1565c0, #17468f) !important;
        color: #ffffff !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        letter-spacing: 0.06em !important;
        border-radius: 10px !important;
        height: 50px !important;
        text-transform: uppercase;
        box-shadow: 0 4px 20px rgba(21,101,192,0.4) !important;
        transition: all 0.2s ease !important;
    }
    .login-submit-btn:hover:not([disabled]) {
        background: linear-gradient(135deg, #1976d2, #1e5cbf) !important;
        box-shadow: 0 6px 26px rgba(21,101,192,0.55) !important;
        transform: translateY(-1px);
    }
    .login-submit-btn[disabled] {
        background: rgba(255,255,255,0.08) !important;
        color: rgba(255,255,255,0.3) !important;
        box-shadow: none !important;
    }
</style>

